import React from 'react';
import MainView from './MainView';

function App() {
  return (
    <div className="App">
      <MainView/>
    </div>
  );
}

export default App;
